import { render, staticRenderFns } from "./TruckDetailsTab.vue?vue&type=template&id=6af179db&scoped=true&"
import script from "./TruckDetailsTab.vue?vue&type=script&lang=js&"
export * from "./TruckDetailsTab.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./TruckDetailsTab.vue?vue&type=style&index=1&id=6af179db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af179db",
  null
  
)

export default component.exports